import React from "react";
import useFlag, { FLAGS } from "../../../hooks/useFlag";
import { ArticleListItemMobile, ListWrapper } from "../styles/styles";
import { Media } from "../types/media";
import { ArticleType } from "@coworker/types/lib/tasks/constants";
import { AggregatedArticleListItem } from "../Molecules/AggregatedArticleListItem";
import { selectArticleIdNbrArticles } from "../Molecules/MediaArticles.helper";
import { AggregatedArticle } from "../hooks/useAggregatedArticles";
import { TaskLinks } from "../types/taskLink";
import {
  ArticleIdNbrArticles,
  Articles,
  EdsData,
  SalesStopData,
} from "../types/article";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { MediasViewSearchListItemSkeleton } from "../Molecules/MediasViewSearchListItemSkeleton";
import { isLocalCombinationArticle } from "../Helpers/articleHelpers";
import { LocalCombinationItemsListView } from "@coworker/apprestructured/src/media-maintenance/components/LocalCombinations/LocalCombinationItemsListView/LocalCombinationItemsListView";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";

interface AggregatedArticleListProps {
  articles: AggregatedArticle[] | undefined;
  combinationArticles: Record<string, Articles>;
  media: Media;
  isSelectArticlesMode: boolean;
  taskLinks: TaskLinks;
  edsData: EdsData[];
  salesStopData: SalesStopData[];
  selectedArticleIdsNbrArticles: ArticleIdNbrArticles[];
  setSelectedArticleIdsNbrArticles: React.Dispatch<
    React.SetStateAction<ArticleIdNbrArticles[]>
  >;
}

export const AggregatedArticleList = React.forwardRef<
  HTMLDivElement,
  AggregatedArticleListProps
>(
  (
    {
      articles,
      combinationArticles,
      media,
      isSelectArticlesMode,
      taskLinks,
      edsData,
      salesStopData,
      selectedArticleIdsNbrArticles,
      setSelectedArticleIdsNbrArticles,
    },
    ref
  ) => {
    if (!articles) {
      return (
        <FixaListView id="articles-list">
          <MediasViewSearchListItemSkeleton key="medias-view-article-0" />
          <MediasViewSearchListItemSkeleton key="medias-view-article-1" />
          <MediasViewSearchListItemSkeleton key="medias-view-article-2" />
          <MediasViewSearchListItemSkeleton key="medias-view-article-3" />
        </FixaListView>
      );
    } else {
      return (
        <ListWrapper ref={ref}>
          {articles.map((uniqueArticle) => (
            <React.Fragment key={`fragment-${uniqueArticle.id}`}>
              <ArticleListItemMobile key={uniqueArticle.id}>
                <AggregatedArticleListItem
                  key={`aggregated-article-${uniqueArticle.id}`}
                  article={uniqueArticle}
                  media={media}
                  taskLinks={taskLinks}
                  edsData={
                    edsData?.find(
                      (eds: { productArticleId: string }) =>
                        eds.productArticleId === uniqueArticle.productArticleId
                    ) ??
                    uniqueArticle.eds ??
                    null
                  }
                  salesStopData={
                    salesStopData?.find(
                      (salesStop) =>
                        salesStop.productArticleId ===
                        uniqueArticle.productArticleId
                    ) ?? null
                  }
                  selectArticleIdsMode={isSelectArticlesMode}
                  handleSelectedItems={(articleIdNbrArticles) =>
                    selectArticleIdNbrArticles(
                      articleIdNbrArticles,
                      selectedArticleIdsNbrArticles,
                      setSelectedArticleIdsNbrArticles
                    )
                  }
                  isSelected={
                    !!selectedArticleIdsNbrArticles.find(
                      (item) => item.articleId === uniqueArticle.id
                    )
                  }
                />
              </ArticleListItemMobile>
              {isLocalCombinationArticle(
                uniqueArticle.productArticleType as ArticleType
              ) && (
                <LocalCombinationItemsListView
                  parentArticle={uniqueArticle}
                  combinationArticles={combinationArticles}
                  edsData={edsData}
                  salesStopData={salesStopData}
                  mediaItemViewType={MediaItemViewType.AGGREGATED_ITEM_VIEW}
                />
              )}
            </React.Fragment>
          ))}
        </ListWrapper>
      );
    }
  }
);
